import { FooterDisclaimer } from 'organisms';
import { NavigateConst } from 'common';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Headings, Paragraph, Button } from '@sentara-health/optimahealth_web';
import ProxyHeader from './ProxyHeader';

const ProxyRegister = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate(NavigateConst.signIn);
  };

  const handleRegisterNow = () => {
    navigate(NavigateConst.registration);
  };

  return (
    <div className="d-flex flex-column h-100">
      <ProxyHeader />
      <div className="container-fluid" aria-live="polite">
        <div
          id="main-content"
          className='container-lg px-main'
        >
          <div data-testid="CSRProxy">
            <div className="row justify-content-center my-5">
              <div className="col-lg-6 col-md-8 col-sm-12">
                {/* Already a member section */}
                <div className="text-center mb-5">
                  <Headings 
                    level={2} 
                    text={t('csrGuardian.alreadyMember')} 
                    variant="semiBold"
                  />
                  <Paragraph
                    text={t('csrGuardian.signInToComplete')}
                    variant="regular"
                    className="my-3"
                  />
                  <Button
                    variant='primary_btn'
                    onClick={handleSignIn}
                    className="px-5 py-2"
                  >
                    {t('common.signIn')}
                  </Button>
                </div>

                {/* Divider */}
                <hr className="my-5" />

                {/* Don't have an account section */}
                <div className="text-center">
                  <Headings 
                    level={2} 
                    text={t('csrGuardian.noAccountYet')} 
                    variant="semiBold"
                  />
                  <Paragraph
                    text={t('csrGuardian.registerToComplete')}
                    variant="regular"
                    className="my-3"
                  />
                  <Button
                    variant='primary_btn'
                    onClick={handleRegisterNow}
                    className="px-5 py-2"
                  >
                    {t('signIn.registerNow')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer section */}
      <footer className="container-lg mt-auto">
        {/* Component to display the footer disclaimer */}
        <FooterDisclaimer />
      </footer>
    </div>
  );
};

export default ProxyRegister;
